// Javascript for homepage feature cards
function initScrollableContainers() {

  // Scroll button logic
  document.querySelectorAll(".scroll-container").forEach(container => {
    if (container.dataset.scrollInitialized === 'true') return;
    container.dataset.scrollInitialized = 'true';

    const wrapper = container.querySelector(".scrolling-wrapper");
    const leftBtn = container.querySelector(".scroll-arrow.left");
    const rightBtn = container.querySelector(".scroll-arrow.right");

    if (!wrapper || !leftBtn || !rightBtn) return;

    const updateArrows = () => {
      const scrollLeft = wrapper.scrollLeft;
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= maxScroll - 1;

      if (atStart) leftBtn.classList.add("hidden");
      else leftBtn.classList.remove("hidden");

      if (atEnd) rightBtn.classList.add("hidden");
      else rightBtn.classList.remove("hidden");
    };

    leftBtn.addEventListener("click", () => {
      wrapper.scrollBy({
        left: -wrapper.clientWidth * 0.8,
        behavior: "smooth"
      });
    });

    rightBtn.addEventListener("click", () => {
      wrapper.scrollBy({
        left: wrapper.clientWidth * 0.8,
        behavior: "smooth"
      });
    });

    wrapper.addEventListener("scroll", updateArrows);

    requestAnimationFrame(updateArrows);
    setTimeout(updateArrows, 50);
  });
}

function initMiniMaps() {
  document.querySelectorAll(".mini-map").forEach(el => {
    if (el.dataset.mapInitialized === 'true') return;

    const startLat = parseFloat(el.dataset.startLat);
    const startLng = parseFloat(el.dataset.startLng);
    const endLat = parseFloat(el.dataset.endLat);
    const endLng = parseFloat(el.dataset.endLng);

    if (!startLat || !endLat) return;

    el.dataset.mapInitialized = 'true';

    const map = L.map(el, {
      keyboard: false,
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
    }).setView([startLat, startLng], 10);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19
    }).addTo(map);

    const bounds = L.latLngBounds([
      [startLat, startLng],
      [endLat, endLng]
    ]);

    map.fitBounds(bounds, { padding: [10, 10] });

    const startMarker = L.marker([startLat, startLng], {
      keyboard: false
    }).addTo(map);

    const endMarker = L.marker([endLat, endLng], {
      keyboard: false
    }).addTo(map);

    L.polyline(
      [[startLat, startLng], [endLat, endLng]],
      { color: '#cc6d2a', weight: 3, dashArray: '6,6' }
    ).addTo(map);
  });
}

function bootHomepage() {
  initScrollableContainers();
  initMiniMaps();
}

document.addEventListener('turbo:load', bootHomepage);
document.addEventListener("DOMContentLoaded", bootHomepage);